import { Text, View } from '@react-pdf/renderer';
import { styles } from '../style/pdfStyles';
import { PdfKeyValueTable } from './PdfKeyValueTable';
import { getReadableLabel, normalizeValue } from '../utils/normalize';
import { isBlacklistedKey } from '../utils/publicFields';

interface PdfModuleProps {
  module: {
    name: string;
    type: string;
    content?: Record<string, string>;
  };
}

export const PdfModule = ({ module }: PdfModuleProps) => {
  const entries = Object.entries(module.content || {}).filter(
    ([label]) => !isBlacklistedKey(label)
  );
  const rows = entries.map(([label, value]) => ({
    label: getReadableLabel(module.type || module.name, label),
    value: normalizeValue(value),
  }));

  return (
    <View>
      <Text style={styles.sectionTitle}>{module.name || 'Modulo'}</Text>
      {module.type ? <Text style={styles.subtitle}>{module.type}</Text> : null}

      <PdfKeyValueTable rows={rows} emptyMessage="Nessun dato disponibile." />
    </View>
  );
};
